import React, {MutableRefObject, useEffect, useRef, useState} from "react";
import {GridColDef, GridRenderCellParams, GridRowModel, GridSelectionModel} from "@mui/x-data-grid";
import {
  Box,
  CircularProgress,
  Collapse,
  FormControl,
  Grid,
  IconButton,
  Input,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
  Menu,
} from "@mui/material";
import Button from '@mui/material/Button';
import CustomDataGrid, {DataGridRef} from "../../../components/data-grid/CustomDataGrid";
import {HREndpoints} from "../../../services/hr/endpoints";
import {Star} from "@mui/icons-material";
import WebURL from "../../../urls";
import CustomRowButton from "../../../components/data-grid/CustomRowButton";
import AvatarIcon from "@/components/avatar/AvatarIcon";
import Dialog from "@/components/dialog";
import SnackbarUtil from "@/utils/SnackbarUtil";
import EmployeeService from "@/services/hr/EmployeeService";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom"
import DeviceService from '@/services/dms/DeviceService';
import {ReactComponent as IconEdit} from '@/assets/icons/IconEdit.svg';
import {ReactComponent as IconMarkResigned} from '@/assets/icons/IconMarkResigned.svg';
import {ReactComponent as IconDeletes} from '@/assets/icons/IconDeletes.svg';
import EmployeeView from "./components/EmployeeView";
import EmployeeNew from "./components/EmployeeNew";
import CustomBreadcrumbs from "@/components/breadcrumbs/CustomBreadcrumbs";
import CredentialService from "@/services/cms/CredentialService";
import {ReactComponent as PasswordIcon} from "@/assets/images/credential/PinIcon.svg";
import {ReactComponent as CardIcon} from "@/assets/images/credential/CardIcon.svg";
import {ReactComponent as FingerprintIcon} from "@/assets/images/credential/FingerPrintIcon.svg";
import {ReactComponent as FingerprintIconGrey} from "@/assets/images/credential/FingerPrintIconGrey.svg";
import {ReactComponent as VisibleFaceIcon} from "@/assets/images/credential/VisibleLightFaceIcon.svg";
import {ReactComponent as VisibleFaceIconGrey} from "@/assets/images/credential/VisibleLightFaceIconGrey.svg";
import Select, {SelectChangeEvent} from "@mui/material/Select";
import {useDispatch, useSelector} from "react-redux";
import {object, TypeOf, z} from "zod";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import ControlAutoComplete from "@/components/hook-form/ControlAutoComplete";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {getOrganDepts} from "@/store/slices/Department";
import InputLabel from '@mui/material/InputLabel';
import ResetEmpPassword from "@/pages/hr/Employee/components/ResetEmpPassword";
import AppAccess from "@/pages/hr/Employee/components/AppAccess";
import ComplianceConfirm from "@/pages/hr/Employee/components/ComplianceConfirm";
import SubscriptionService from "@/services/subscription/SubscriptionService";
import {ReactComponent as AppAccessDisableIcon} from "@/assets/person/AppAccessDisable.svg";
import {ReactComponent as AppAccessEnableIcon} from "@/assets/person/AppAccessEnable.svg";
import {ReactComponent as EmpActionIcon} from "@/assets/person/IconEmpAction.svg";
import UserService from "@/services/auth/UserService";
import {useSnackbar} from "notistack";


type hoverType = "PINdisplay" | "CARDdisplay" | "FPdisplay" | "VLFdisplay";

enum registrationType {
  "Common",
  "FingerPrint",
  "Face",
  "Voiceprint",
  "Iris",
  "Retina",
  "Palmprint",
  "Fingervein",
  "Palm",
  "Visible Light Face",
  "Password" = 102,
  "Card" = "card",
}

// enum registrationType {
//   "Password" = 102,
//   "Card" = "card",
// }


const FingerSelect: React.FC<{ cRef: MutableRefObject<any> }> = (props) => {
  const {t} = useTranslation();
  const fingerOptions = [
    {value: "4", option: t("dms.Left Thumb")},
    {value: "3", option: t("dms.Left First Finger")},
    {value: "2", option: t("dms.Left Middle Finger")},
    {value: "1", option: t("dms.Left Ring Finger")},
    {value: "0", option: t("dms.Left Little Finger")},
    {value: "5", option: t("dms.Right Thumb")},
    {value: "6", option: t("dms.Right First Finger")},
    {value: "7", option: t("dms.Right Middle Finger")},
    {value: "8", option: t("dms.Right Ring Finger")},
    {value: "9", option: t("dms.Right Little Finger")},
  ];

  const [selected, setSelected] = useState("4");
  const handleChange = (event: SelectChangeEvent) => {
    setSelected(event.target.value);
    props.cRef.current = event.target.value;
  };

  return (
    <FormControl fullWidth>
      <Select value={selected} onChange={handleChange}>
        {fingerOptions.map((option, idx) => (
          <MenuItem key={idx} value={option.value}>
            {option.option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const EmployeeDataGrid: React.FC = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const dataGridRef = useRef<DataGridRef>();
  const employeeViewRef = useRef<any>({})
  const employeeNewRef = useRef<any>({})
  const [refresh, setRefresh] = useState<boolean>(true);
  const [loading, setLoading] = React.useState(false);
  const [click, setClick] = React.useState(false);
  const [paymentStatus, setPaymentStatus] = React.useState<any>("");
  const [bioCollection, setBioCollection] = React.useState(false);
  const [selectionDeviceModel, setSelectionDeviceModel] =
    useState<GridSelectionModel>([]);
  const type = useRef(0)
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // 打开菜单
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  // 关闭菜单
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // 阻止事件冒泡到Menu
    // 保留anchorEl，避免菜单关闭导致弹窗失去上下文
    // 菜单关闭逻辑由AppAccess内部完成，而非这里
  };
  const processRowUpdate = async (
    newRow: GridRowModel,
    oldRow: GridRowModel
  ) => {
    if (newRow.role === oldRow.role) return oldRow;
    try {
      setLoading(true);
      await CredentialService.updateUserRole(newRow.id, newRow);
      SnackbarUtil.success(t("dms.Role Updated Successfully"));
      return newRow;
    } catch (e) {
      return oldRow;
    } finally {
      setLoading(false);
    }
  };
  const sumCredentialCount = (credentialCount?: {}) => {
    if (typeof credentialCount === "undefined") return 0;
    const countList: any = Object.values(credentialCount);
    if (countList.length > 0)
      return countList.reduce((x: number, y: number) => x + y);
    return 0;
  };
  const dispatch = useDispatch();
  const depts: { id: string, name: string }[] = useSelector((state: any) => state.dept.depts);
  const [dept, setDept] = React.useState<string>("");
  const [filterParams, setFilterParams] = useState<Record<any, any>>({
    departments: dept
  });
  const deviceId = React.useRef();
  const getOrganDevice = createAsyncThunk('device/byOrgan', async (enroll_index: number) => {
    const {data} = await DeviceService.list({current: 1, pageSize: 50, enroll_index: enroll_index});
    return data;
  })
  const deviceValidate = object({
    sn: z
      .string({required_error: t("common.This field is required!")})
      .min(1, t("common.This field is required!"))
      .max(
        30,
        t("common.The length of field cannot exceed digits", {number: 30})
      ),
  });
  type deviceInput = TypeOf<typeof deviceValidate>;
  const select_device: { id: string; sn: string }[] = useSelector(
    (state: any) => {
      return state.device.devices;
    }
  );
  const deviceForm = useForm<deviceInput>({
    resolver: zodResolver(deviceValidate)
  });
  const DeviceComponent = () => {
    return (<>
        <Typography
          sx={{
            marginTop: "12px !important",
            marginBottom: "8px !important",
            fontSize: "14px !important",
            color: "#000000",
          }}
        >
          {t("common.quickly setting device four")}
        </Typography>
        <Grid
          sx={{
            maxWidth: "60vw",
            maxHeight: "50px",
            // ".MuiOutlinedInput-root": {padding: "1px"},
            // position: "center"
            marginBottom: "5px",
          }}
        >
          <ControlAutoComplete
            name={"sn"}
            form={deviceForm}
            label={""}
            options={select_device}
            multi={false}
            onChange={(event) => {
              // scheduleForm.setValue("device_list", event);
              deviceId.current = event?.id;
            }}
          />
        </Grid></>
    );
  };

  useEffect(() => {
    dispatch<any>(getOrganDevice(type.current));
  }, [click])
  useEffect(() => {
    dispatch<any>(getOrganDepts());
    SubscriptionService.getPaymentStatus().then((res: any) => {
      if (res.status < 400) {
        setPaymentStatus(res.data?.data?.subscription_status)
      }
    })
    UserService.compliance_operation({}, 'GET').then(
      (result) => {
        setBioCollection(result.data?.company_compliance?.bio_collection || false)
      }
    )
  }, [])
  const RegistrationRender =
    (refresh: () => void) => (params: GridRenderCellParams) => {
      const {t} = useTranslation();
      const cRef = useRef("");
      const row = params.row;
      const pwRef = useRef("")
      const {enqueueSnackbar} = useSnackbar();
      const [hoverDisplay, setHoverDisplay] = React.useState({
        PINdisplay: false,
        CARDdisplay: false,
        FPdisplay: false,
        VLFdisplay: false,
      });

      const handleMouseHover = (
        event: React.MouseEvent<HTMLElement>,
        type: hoverType
      ) => {
        if (event) setHoverDisplay({...hoverDisplay, [type]: false});
      };

      const handleMouseOut = (
        event: React.MouseEvent<HTMLElement>,
        type: hoverType
      ) => {
        if (event) setHoverDisplay({...hoverDisplay, [type]: false});
      };

      const {PINdisplay, CARDdisplay, FPdisplay, VLFdisplay} = hoverDisplay;

      const credRegistration = (type: number | string) => {
        cRef.current = "4"; //default finger is left thumb
        const cred_name =
          typeof type === "number" ? registrationType[type] : type;
        Dialog.confirm({
          width: "500px",
          title: t("dms.Remote registration title", {type: cred_name}),
          helpInfo: t("dms.Require complete on device"),
          // description:
          //   type == registrationType.FingerPrint
          //     ? t(`dms.Which finger you want to choose?`)
          //     : t("dms.Are you sure to register type {} remotely?", {
          //       type: cred_name,
          //     }),
          content:
            type == registrationType.FingerPrint ? (
              <>
                <DeviceComponent/>
                <Typography>
                  {t(`common.FingerPrint`)}
                </Typography>
                <FingerSelect cRef={cRef}/>
              </>
            ) : (
              <DeviceComponent/>
            ),
          onConfirm: () => {
            if (deviceId.current) {
              DeviceService.remoteRegistration(deviceId.current, {
                enrollType: type,
                pin: row.employeeCode,
                fid: cRef.current || "1",
                personId: row.id,
              }).then((result) => {
                if (result.status < 400) {
                  SnackbarUtil.success(
                    t("dms.Command has been sent successfully", {
                      msg: result.data?.data?.msg,
                    }),
                    {autoHideDuration: 5000}
                  );
                  setTimeout(function () {
                    refresh();
                  }, 8000);
                  //waiting registration, then query template count again
                }
              });
            } else {
              SnackbarUtil.error(t("common.Select device first"), {
                anchorOrigin: {
                  vertical: 'top',
                  horizontal: 'center'
                }
              })
              return
            }
          },
        });
      };

      const pwdRegistration = () => {
        pwRef.current = ''
        Dialog.confirm({
          title: t("dms.Are you sure to register a new password?"),
          // description: t("dms.Please set a password"),
          content: (
            <Grid>
              <DeviceComponent/>
              <Typography>
                {t("dms.Please set a password")}
              </Typography>
              <Input
                type={"password"}
                onChange={(event) => {
                  cRef.current = event.target.value;
                  pwRef.current = event.target.value
                }
                }
              />
              <p style={{fontSize: "0.75rem", color: "#f29548"}}>
                {t("dms.Set password tip")}
              </p>
            </Grid>
          ),
          onConfirm: () => {
            if (!deviceId.current) {
              SnackbarUtil.error(t("common.Select device first"), {
                anchorOrigin: {
                  vertical: 'top',
                  horizontal: 'center'
                }
              })
              return
            }
            if (!pwRef.current) {
              //interface not allow empty pwd
              SnackbarUtil.error(t("dms.Please input a valid password"), {
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "center",
                },
              });
              return;
            }
            const condition = {
              personIdOrCode: row.id,
              passcode: pwRef.current,
              deviceId: deviceId.current,
            };
            CredentialService.setPersonPassword(condition).then((result) => {
              if (result.status < 400) SnackbarUtil.success(result.data.message);
              refresh();
            });
          },
        });
      };

      const isAllowRegistration = (type: number | string) => {
        if (Number(params.row.status) === 0) {
          //offline
          SnackbarUtil.error(t("dms.Offline device not allow registration"), {
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
          return;
        } else {
          if (type === registrationType.Password) return pwdRegistration();
          else return credRegistration(type);
        }
      };

      return (
        <Stack direction={"row"} spacing={1} sx={{marginLeft: "-5px"}}>
          <Tooltip title={t("dms.Register Password")} placement="top">
            <IconButton
              name="PIN"
              disableRipple
              onMouseEnter={(e) => handleMouseHover(e, "PINdisplay")}
              onMouseLeave={(e) => handleMouseOut(e, "PINdisplay")}
              onClick={() => {
                type.current = 3
                setClick(!click)
                isAllowRegistration(registrationType.Password)
              }}
            >
              <PasswordIcon/>
            </IconButton>
          </Tooltip>
          <Collapse in={PINdisplay} orientation="horizontal">
            <Grid sx={{fontSize: "16px", paddingTop: "16px"}}>
              {params.row.credentialCount?.passcode}
            </Grid>
          </Collapse>

          <Tooltip title={t("dms.Register Card")} placement="top">
            <IconButton
              name="Card"
              disableRipple
              onMouseEnter={(e) => handleMouseHover(e, "CARDdisplay")}
              onMouseLeave={(e) => handleMouseOut(e, "CARDdisplay")}
              onClick={() => {
                type.current = 2
                setClick(!click)
                isAllowRegistration(registrationType.Card)
              }}
            >
              <CardIcon/>
            </IconButton>
          </Tooltip>
          <Collapse in={CARDdisplay} orientation="horizontal">
            <Grid sx={{fontSize: "16px", paddingTop: "16px"}}>
              {params.row.credentialCount?.card}
            </Grid>
          </Collapse>

          <Tooltip title={t("dms.Register Fingerprint")} placement="top">
            <IconButton
              name="FP"
              disableRipple
              onMouseEnter={(e) => handleMouseHover(e, "FPdisplay")}
              onMouseLeave={(e) => handleMouseOut(e, "FPdisplay")}
              onClick={() => {
                if (!bioCollection) {
                  enqueueSnackbar(t("common.Please enable the biometric collection switch on the Person page first."), {
                    variant: "warning",
                    autoHideDuration: 3000,
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "center"
                    }
                  })
                  return
                }
                type.current = 0
                setClick(!click)
                isAllowRegistration(registrationType.FingerPrint)
              }}
            >
              {bioCollection ? <FingerprintIcon/> : <FingerprintIconGrey/>}
            </IconButton>
          </Tooltip>
          <Collapse in={FPdisplay} orientation="horizontal">
            <Grid sx={{fontSize: "16px", paddingTop: "16px"}}>
              {params.row.credentialCount?.fingerPrint}
            </Grid>
          </Collapse>

          <Tooltip title={t("dms.Register Visible Light Face")} placement="top">
            <IconButton
              name="VLF"
              disableRipple
              onMouseEnter={(e) => handleMouseHover(e, "VLFdisplay")}
              onMouseLeave={(e) => handleMouseOut(e, "VLFdisplay")}
              onClick={() => {
                if (!bioCollection) {
                  enqueueSnackbar(t("common.Please enable the biometric collection switch on the Person page first."), {
                    variant: "warning",
                    autoHideDuration: 3000,
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "center"
                    }
                  })
                  return
                }
                type.current = 1
                setClick(!click)
                isAllowRegistration(registrationType["Visible Light Face"])
              }}
            >
              {bioCollection ? <VisibleFaceIcon/> : <VisibleFaceIconGrey/>}
            </IconButton>
          </Tooltip>
          <Collapse in={VLFdisplay} orientation="horizontal">
            <Grid sx={{fontSize: "16px", paddingTop: "16px"}}>
              {params.row.credentialCount?.visibleLightFace}
            </Grid>
          </Collapse>
        </Stack>
      );
    };
  const AppAccessField = (params: GridRenderCellParams) => {
    if (paymentStatus) {
      if (params.value) {
        return <AppAccessEnableIcon/>;
      } else {
        return <AppAccessDisableIcon/>;
      }
    } else {
      return ''
    }
  };
  const columns: GridColDef[] = [
    {
      field: 'firstName', headerName: t("common.Person Name"), flex: 0.2, minWidth: 150, renderCell: (params) => {
        return (
          <Grid style={{display: "flex", alignItems: "center"}}>
            <Box style={{position: 'relative', paddingLeft: 10, marginBottom: '60px'}}>
              {params.row.role === "ADMINSTRATOR" && <Star sx={{
                color: "#FFD700",
                position: 'absolute',
                top: 0,       // 顶部对齐
                left: 0,      // 左侧对齐
                fontSize: 24, // 调整图标大小
                zIndex: 1     // 确保显示在内容上方
              }}/>}
            </Box>
            <AvatarIcon name={params.row?.firstName || params.row?.lastName}/>
            <Box style={{padding: '0 8px'}}>{params.row.firstName} {params.row.lastName}</Box>
          </Grid>
        )
      }
    },
    {field: 'employeeCode', headerName: t("common.Person ID"), type: "string", flex: 0.1, minWidth: 120},
    {field: 'email', headerName: t("common.Email"), type: "string", flex: 0.1, minWidth: 180},
    // {field: 'phone', headerName: t("common.Mobile"), type: "string", minWidth: 180},
    {field: 'department_name', headerName: t("common.Department"), type: "string", flex: 0.1, minWidth: 180},
    {
      field: "role",
      headerName: t("dms.Role in device"),
      minWidth: 100,
      flex: 0.1,
      editable: true,
      type: "singleSelect",
      valueOptions: ["ADMINSTRATOR", "COMMONUSER"],
      valueFormatter: (params) => {
        if (params.value == "ADMINSTRATOR")
          // CMS admin word misspelling
          return t("dms.Device role Administrator");
        return t("dms.Device role CommonUser");
      },
    },
    {
      field: "registration",
      headerName: t("dms.Remote registration"),
      headerAlign: "left",
      minWidth: 240,
      flex: 0.2,
      sortable: false,
      renderCell: RegistrationRender(() => setRefresh(!refresh)),
    },
    {
      field: 'verify',
      headerName: !paymentStatus ? "" : t("common.App Access"),
      type: "string",
      flex: !paymentStatus ? 0 : 0.1,
      minWidth: !paymentStatus ? 0 : 50,
      renderCell: AppAccessField,
      align: 'center'
    },
    {
      field: 'actions',
      hideSortIcons: true,
      flex: 0.3,
      minWidth: 150,
      headerName: t("common.action"),
      headerAlign: 'left',
      align: 'left',
      sortable: false,
      renderCell: (e) => {
        return (
          <Stack direction={"row"} spacing={1} sx={{marginLeft: "-5px"}}>
            <CustomRowButton insideSvgIcon={IconEdit} actionName={t("common.edit")} buttonProps={{
              key: "edit",
              onClick: () => {
                employeeViewRef?.current?.showDetail(e.row.id)
                // navigate(WebURL.HR_EMPLOYEE_VIEW, {state: {id: e.row.id}});
              }
            }}/>
            <CustomRowButton insideSvgIcon={IconMarkResigned} actionName={t("common.Resigned")} buttonProps={{
              key: "Resigned",
              onClick: async () => {
                Dialog.confirm({
                  // width: "650px",
                  title: t("hr.resignation.Resignation"),
                  content: t("hr.resignation.You sure to resign?", {value: e.row.firstName + " " + e.row.lastName}),
                  helpInfo: t("hr.resignation.Resign Tip"),
                  onConfirm: () => {
                    EmployeeService.resign(e.row.id).then((response) => {
                      SnackbarUtil.success(t('common.success'))
                      dataGridRef.current?.refresh();
                    });
                  }
                });
              }
            }}/>
            <CustomRowButton insideSvgIcon={IconDeletes} actionName={t("common.delete")} buttonProps={{
              key: "delete",
              onClick: async () => {
                Dialog.confirm({
                  title: t("common.Delete Employee"),
                  content: t("common.You sure to delete?", {value: e.row.firstName + " " + e.row.lastName}),
                  onConfirm: () => {
                    DeviceService.deleteEmpInDevice({personId: e.row.id}).then((response) => {
                      if (response?.code == "TDMSE1001") {
                        SnackbarUtil.error(t("common.Person in device text"), {
                          anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'center'
                          }
                        })
                        return
                      } else if (response?.code == "TDMSE1002") {
                        SnackbarUtil.error(t("common.Deleting the person wrong"), {
                          anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'center'
                          }
                        })
                        return
                      } else {
                        SnackbarUtil.success(t('common.success'))
                        dataGridRef.current?.refresh();
                      }
                    });
                  }
                });
              }
            }}/>
          </Stack>
        )
      }
    }
  ]
  const reloadTable = () => {
    dataGridRef.current?.refresh();
  }

  function debounce(fn: any, delay: any) {
    let timer: any;
    return function (...args: any) {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  }

  const debouncedSave = debounce((newValue: any) => {
    // 这里是你的保存操作
    reloadTable()
  }, 1000);

  useEffect(() => {
    debouncedSave(dept);
  }, [dept]);
  const [gridData, setGridData] = useState([]);
  const [selectionData, setSelectionData] = useState<Record<string, any>>([]);
  const handleDataGridSave = (value: any) => {
    if (value) {
      setGridData(value)
    }
  }
  const clearSelectionData = () => {
    setSelectionData([]);
    setSelectionDeviceModel([])
    handleClose()
  };
  return (
    <>
      <CustomBreadcrumbs record={[{label: t("common.Person")}]}/>
      <CustomDataGrid
        uri={HREndpoints.HR_EMPLOYEE_URI}
        columns={columns}
        ref={dataGridRef}
        checkboxSelection={true}
        columnVisibilityModel={{
          deviceId: false,
        }}
        isCellEditable={(params) =>
          sumCredentialCount(params.row.credentialCount) > 0
        } // 该人员有credential才能设置管理员
        processRowUpdate={processRowUpdate}
        experimentalFeatures={{newEditingApi: true}}
        onDataChange={handleDataGridSave}
        onSelectionModelChange={(ids) => {
          setSelectionDeviceModel(ids)
          setSelectionData(ids.map((id) => gridData.find((row: any) => row.id === id)));
        }}
        selectionModel={selectionDeviceModel}
        requestParams={filterParams}
        toolbar={{
          title: t("common.Person"),
          searchTips: t("common.Search by Person First Name"),
          breadcrumbs: [
            {breadcrumbName: t("common.Person"), path: WebURL.HR_EMPLOYEE}
          ],
          extraComponent:
            <Grid sx={{paddingRight: "1vw"}}>
              <FormControl fullWidth sx={{
                marginLeft: "10px",
                width: "220px",
                display: 'flex',
                justifyContent: 'center'
              }}>
                <InputLabel
                  id="department-select-helper-label"
                  sx={{
                    textAlign: "center",
                    width: '100%',
                    left: 0,
                    top: '50%',
                    transform: 'translate(0, -50%) scale(0.85)',
                    '&.MuiInputLabel-shrink': {
                      textAlign: "left",
                      left: 10,
                      top: 0,
                      transform: 'translate(0, -50%) scale(0.85)',
                    },
                    '&.Mui-focused': {
                      textAlign: "left",
                      left: 10,
                      top: 0,
                      transform: 'translate(0, -50%) scale(0.85)',
                    }
                  }}
                >
                  {t('hr.department.Department')}
                </InputLabel>
                <Select
                  labelId="department-select-label"
                  id="department-select"
                  value={dept}
                  label={t('hr.department.Department')}
                  size={'medium'}
                  onChange={(e) => {
                    setDept(e.target.value)
                    setFilterParams({departments: e.target.value})
                  }}
                >
                  <MenuItem key={''} value={''}>-----</MenuItem>
                  {depts.map(dept => (
                    <MenuItem key={dept.id} value={dept.id}>
                      {dept.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          ,
          actions: [{
            key: 'add', iconFont: 'icon-ic_add', helpTxt: t("common.add"), callback: async () => {
              employeeNewRef?.current?.showAdd()
              // navigate(WebURL.HR_EMPLOYEE_NEW);
            }
          }],
          extraComponentOnRight: (
            <Grid
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'nowrap'
              }}
            >
              <ComplianceConfirm/>
              {paymentStatus && (
                <>
                  <Button
                    id="bulk-actions-button"
                    aria-controls={open ? 'bulk-actions-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    startIcon={<EmpActionIcon/>}
                    variant="text"
                    sx={{
                      color: "rgb(117, 130, 138)",
                      fontSize: "14px !important",
                      textTransform: 'none !important',
                      fontFamily: 'Roboto, Helvetica, Arial, sans-serif !important',
                      fontWeight: 'normal',
                      lineHeight: 1.5,
                    }}
                  >
                    {t("common.Bulk Actions")}
                  </Button>

                  <Menu
                    id="bulk-actions-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      'aria-labelledby': 'bulk-actions-button',
                    }}
                  >
                    <MenuItem key='ResetEmpPassword' onClick={handleMenuItemClick}>
                      <ResetEmpPassword employees={selectionData}/>
                    </MenuItem>

                    <MenuItem key='AppAccessEnable' onClick={handleMenuItemClick}>
                      <AppAccess employees={selectionData} enable={true} reloadTable={reloadTable} onComplete={clearSelectionData}/>
                    </MenuItem>

                    <MenuItem key='AppAccessDisable' onClick={handleMenuItemClick}>
                      <AppAccess employees={selectionData} enable={false} reloadTable={reloadTable} onComplete={clearSelectionData}/>
                    </MenuItem>
                  </Menu>
                </>
              )}
            </Grid>
          ),
        }}
      />
      <EmployeeView ref={employeeViewRef} reloadTable={reloadTable} paymentStatus={paymentStatus}></EmployeeView>
      <EmployeeNew ref={employeeNewRef} reloadTable={reloadTable} paymentStatus={paymentStatus}></EmployeeNew>
      <CircularProgress
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          display: loading ? "block" : "none",
          zIndex: 1,
        }}
      />
    </>
  )
}
export default EmployeeDataGrid
